import React from 'react'
import {Field, FormikErrors} from 'formik'

interface Props {
  containerClassName?: string
  label?: string
  name: string
  type?: string
  placeholder?: string
  onChange: (e: React.ChangeEvent<any>) => void
  className?: string
  errors: FormikErrors<any>
  touched: any
  labelClassName?: string
  required?: boolean
  checkBoxText: string
  value: string | number | boolean
  defaultValue?: any
}

const FormRadio = React.memo((props: Props) => {
  const {
    containerClassName,
    label,
    name,
    type,
    className,
    errors,
    touched,
    labelClassName,
    required,
    checkBoxText,
    value,
    defaultValue,
    ...rest
  } = props

  const radioId = `${name}-${String(value).replace(/\s+/g, '-')}`

  return (
    <div className={containerClassName ?? 'col-lg-6 '}>
      <div className='form-check form-check-custom form-check-solid me-10'>
        <Field
          id={radioId}
          name={name}
          type={type || 'radio'}
          value={value}
          defaultValue={defaultValue}
          className={className || 'form-check-input h-25px w-25px'}
          data-cy={`${name}-${value}-radio-field`}
          aria-required={required ? 'true' : undefined}
          {...rest}
        />
        <label className='form-check-label' htmlFor={radioId}>
          {checkBoxText}
        </label>
      </div>
    </div>
  )
})

export default FormRadio
